import { useState, useEffect } from "react";
import { InventoryStatsData } from "../../@types/inventory";
import { getInventoryStats } from "../../backend-services";

export function useInventoryStatsData(startDate: Date, endDate: Date) {
  const [inventoryStats, setInventoryStats] =
    useState<InventoryStatsData | null>(null);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    const start = startDate.toISOString();
    const end = endDate.toISOString();

    try {
      const response = await getInventoryStats(start, end);
     
      setInventoryStats(response);
      setError(null);
    } catch (error) {
      setError("Failed to fetch inventory statistics");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { inventoryStats, error };
}
